import { inject } from "@angular/core";
import { CanActivateChildFn, Router } from "@angular/router";
import { map, take } from "rxjs";
import { Role } from "../dtos/user.dto";
import { SessionService } from "../services/session.service";

export const kycGuard: CanActivateChildFn = (route, state) => {
  const session = inject(SessionService);
  const router = inject(Router);

  const businessId =
    route.params["businessId"] ||
    route.parent?.params["businessId"] ||
    route.parent?.parent?.params["businessId"];

  const segments = router.parseUrl(state.url).root.children["primary"]?.segments.map((s) => s.path) ?? [];
  const businessIdIndex = businessId ? segments.indexOf(String(businessId)) : -1;
  const nextSegment = businessIdIndex >= 0 ? segments[businessIdIndex + 1] : undefined;
  const isSettingsRoute = nextSegment === "settings";
  const isDashboardRoute = nextSegment === "dashboard" || !nextSegment;

  return session.loadCurrentUser().pipe(
    take(1),
    map((user) => {
      const matchedBusiness = user?.businessUsers?.find((entry) => entry.businessId === businessId || entry.business?.id === businessId);
      const kycStatus = matchedBusiness?.business?.kycStatus;
      const role = matchedBusiness?.role;
      const isKybActive = kycStatus === "active";

      if (!businessId || isKybActive) {
        return true;
      }

      // Project managers cannot complete KYB in Settings — keep them on dashboard.
      if (role === Role.PROJECT_MANAGER) {
        if (isDashboardRoute) {
          return true;
        }
        return router.createUrlTree(["/", businessId, "dashboard"]);
      }

      // Account managers complete KYB via Settings.
      if (isSettingsRoute) {
        return true;
      }
      return router.createUrlTree(["/", businessId, "settings"]);
    }),
  );
};
